/* eslint-disable max-lines */
import { getPropByPlatType } from '@/components/PlatformList/components/labelIcon/index'
export const PLATFORM_ALL_KEY = undefined
export const PLATFORM_DOUYIN_KEY = 'douyin'
export const PLATFORM_KUAISHOU_KEY = 'kuaishou'
export const PLATFORM_TAOBAO_KEY = 'taobao'
export const PLATFORM_PDD_KEY = 'Pinduoduo'
export const PLATFORM_TMALL_KEY = 'Tmall'
export const PLATFORM_YZ_KEY = 'kdt'
export const PLATFORM_ALIBABA_KEY = 'alibaba'
export const PLATFORM_JD_KEY = 'jos'
export const PLATFORM_VIP_KEY = 'vipapis'
export const PLATFORM_WXSTORE_KEY = 'WXStore'
/**
 * 微信小店供货商
 */
export const PLATFORM_WXSupDS_KEY = 'WXSupDS'
export const PLATFORM_WXCHANNEL_KEY = 'WXChannel'
export const PLATFORM_XHBOOK_KEY = 'Xiaohs'
export const PLATFORM_WEIMOBLS_KEY = 'WeimobLS' // 微盟零售店
export const PLATFORM_MTSHANGOU_KEY = 'MTShanGou' // 美团闪购
export const PLATFORM_JDDAOJIA_KEY = 'JDDaoJia' // 京东到家
export const PLATFORM_EBRETAIL_KEY = 'ElementLS' // 淘宝闪购
export const PLATFORM_KUAITT_KEY = 'KuaiTT' // 快团团
export const PLATFORM_C2M_KEY = 'C2M' // 淘工厂
export const PLATFORM_OFFLINE_KEY = 'Offline' // 线下

export const PLATFORM_LIST = [
    {
        name: '全部',
        value: PLATFORM_ALL_KEY,
    },
    {
        name: '可批量铺货抖音',
        value: PLATFORM_DOUYIN_KEY,
    },
    {
        name: '可批量铺货拼多多',
        value: PLATFORM_PDD_KEY,
    },
    {
        name: '可批量铺货淘宝',
        value: PLATFORM_TAOBAO_KEY,
    },
    {
        name: '可批量铺货天猫',
        value: PLATFORM_TMALL_KEY,
    },
    {
        name: '可批量铺货快手',
        value: PLATFORM_KUAISHOU_KEY,
    },
]

export const LIST = [
    {
        name: '全部',
        value: PLATFORM_ALL_KEY,
    },
    {
        name: '抖音',
        value: PLATFORM_DOUYIN_KEY,
    },
    {
        name: '拼多多',
        value: PLATFORM_PDD_KEY,
    },
    {
        name: '淘宝',
        value: PLATFORM_TAOBAO_KEY,
    },
    {
        name: '天猫',
        value: PLATFORM_TMALL_KEY,
    },
    {
        name: '快手',
        value: PLATFORM_KUAISHOU_KEY,
    },
    {
        name: '阿里巴巴',
        value: PLATFORM_ALIBABA_KEY,
    },
    {
        name: '京东',
        value: PLATFORM_JD_KEY,
    },
    {
        name: '小红书',
        value: PLATFORM_XHBOOK_KEY,
    },
    {
        name: '微信小店',
        value: PLATFORM_WXCHANNEL_KEY,
    },
    {
        name: '微盟零售',
        value: PLATFORM_WEIMOBLS_KEY,
    },
    {
        name: '美团闪购',
        value: PLATFORM_MTSHANGOU_KEY,
    },
    {
        name: '京东到家',
        value: PLATFORM_JDDAOJIA_KEY,
    },
    {
        name: '淘宝闪购',
        value: PLATFORM_EBRETAIL_KEY,
    },
    {
        name: '有赞',
        value: PLATFORM_YZ_KEY,
    },

    {
        name: '唯品会',
        value: PLATFORM_VIP_KEY,
    },
]

export const LIST_CARRY_ICON = [
    {
        name: '全部',
        value: PLATFORM_ALL_KEY,
    },
    {
        name: '抖音',
        value: PLATFORM_DOUYIN_KEY,
        iconObj: getPropByPlatType(PLATFORM_DOUYIN_KEY),
    },
    {
        name: '拼多多',
        value: PLATFORM_PDD_KEY,
        iconObj: getPropByPlatType(PLATFORM_PDD_KEY),
    },
    {
        name: '淘宝',
        value: PLATFORM_TAOBAO_KEY,
        iconObj: getPropByPlatType(PLATFORM_TAOBAO_KEY),
    },
    {
        name: '天猫',
        value: PLATFORM_TMALL_KEY,
        iconObj: getPropByPlatType(PLATFORM_TMALL_KEY),
    },
    {
        name: '快手',
        value: PLATFORM_KUAISHOU_KEY,
        iconObj: getPropByPlatType(PLATFORM_KUAISHOU_KEY),
    },
    {
        name: '阿里巴巴',
        value: PLATFORM_ALIBABA_KEY,
        iconObj: getPropByPlatType(PLATFORM_ALIBABA_KEY),
    },
    {
        name: '京东',
        value: PLATFORM_JD_KEY,
        iconObj: getPropByPlatType(PLATFORM_JD_KEY),
    },
    {
        name: '小红书',
        value: PLATFORM_XHBOOK_KEY,
        iconObj: getPropByPlatType(PLATFORM_XHBOOK_KEY),
    },
    {
        name: '微信小店',
        value: PLATFORM_WXCHANNEL_KEY,
        iconObj: getPropByPlatType(PLATFORM_WXCHANNEL_KEY),
    },
    {
        name: '微盟零售',
        value: PLATFORM_WEIMOBLS_KEY,
        iconObj: getPropByPlatType(PLATFORM_WEIMOBLS_KEY),
    },
    {
        name: '美团闪购',
        value: PLATFORM_MTSHANGOU_KEY,
        iconObj: getPropByPlatType(PLATFORM_MTSHANGOU_KEY),
    },
    {
        name: '京东到家',
        value: PLATFORM_JDDAOJIA_KEY,
        iconObj: getPropByPlatType(PLATFORM_JDDAOJIA_KEY),
    },
    {
        name: '淘宝闪购',
        value: PLATFORM_EBRETAIL_KEY,
        iconObj: getPropByPlatType(PLATFORM_EBRETAIL_KEY),
    },
    {
        name: '有赞',
        value: PLATFORM_YZ_KEY,
        iconObj: getPropByPlatType(PLATFORM_YZ_KEY),
    },

    {
        name: '唯品会',
        value: PLATFORM_VIP_KEY,
        iconObj: getPropByPlatType(PLATFORM_VIP_KEY),
    },
]

// 设置禁售平台
export const LIMIT_SHELVES_PLATFORM_CARRY_ICON = [
    {
        name: '全部',
        value: PLATFORM_ALL_KEY,
    },
    {
        name: '抖音',
        value: PLATFORM_DOUYIN_KEY,
        iconObj: getPropByPlatType(PLATFORM_DOUYIN_KEY),
    },
    {
        name: '拼多多',
        value: PLATFORM_PDD_KEY,
        iconObj: getPropByPlatType(PLATFORM_PDD_KEY),
    },
    {
        name: '淘宝',
        value: PLATFORM_TAOBAO_KEY,
        iconObj: getPropByPlatType(PLATFORM_TAOBAO_KEY),
    },
    {
        name: '天猫',
        value: PLATFORM_TMALL_KEY,
        iconObj: getPropByPlatType(PLATFORM_TMALL_KEY),
    },
    {
        name: '快手',
        value: PLATFORM_KUAISHOU_KEY,
        iconObj: getPropByPlatType(PLATFORM_KUAISHOU_KEY),
    },
    {
        name: '阿里巴巴',
        value: PLATFORM_ALIBABA_KEY,
        iconObj: getPropByPlatType(PLATFORM_ALIBABA_KEY),
    },
    {
        name: '京东',
        value: PLATFORM_JD_KEY,
        iconObj: getPropByPlatType(PLATFORM_JD_KEY),
    },
    {
        name: '小红书',
        value: PLATFORM_XHBOOK_KEY,
        iconObj: getPropByPlatType(PLATFORM_XHBOOK_KEY),
    },
    {
        name: '微信小店',
        value: PLATFORM_WXCHANNEL_KEY,
        iconObj: getPropByPlatType(PLATFORM_WXCHANNEL_KEY),
    },
    {
        name: '微盟零售',
        value: PLATFORM_WEIMOBLS_KEY,
        iconObj: getPropByPlatType(PLATFORM_WEIMOBLS_KEY),
    },
    {
        name: '美团闪购',
        value: PLATFORM_MTSHANGOU_KEY,
        iconObj: getPropByPlatType(PLATFORM_MTSHANGOU_KEY),
    },
    {
        name: '京东到家',
        value: PLATFORM_JDDAOJIA_KEY,
        iconObj: getPropByPlatType(PLATFORM_JDDAOJIA_KEY),
    },
    {
        name: '有赞',
        value: PLATFORM_YZ_KEY,
        iconObj: getPropByPlatType(PLATFORM_YZ_KEY),
    },
    {
        name: '唯品会',
        value: PLATFORM_VIP_KEY,
        iconObj: getPropByPlatType(PLATFORM_VIP_KEY),
    },
    {
        name: '快团团',
        value: PLATFORM_KUAITT_KEY,
        iconObj: getPropByPlatType(PLATFORM_KUAITT_KEY),
    },
    {
        name: '淘工厂',
        value: PLATFORM_C2M_KEY,
        iconObj: getPropByPlatType(PLATFORM_C2M_KEY),
        tips: '暂不支持铺货，禁售后分销商无法推单',
    },
    {
        name: '线下',
        value: PLATFORM_OFFLINE_KEY,
        iconObj: getPropByPlatType(PLATFORM_OFFLINE_KEY),
    },
]
